<template>
  <div :class="['ph-app__container', 'logo']">
    <template>
      <img class="ph-app__background" :src="creativeData['bg_url']"/>
      <div class="ph-app__perview ph-icon__perview">
        <img class="ph-icon__perview-img" :src="creativeData['preview_url']" />
      </div>
    </template>
    <ph-dialog
      title="取消后将以默认样式展示"
      :show.sync="show"
      :showCancelButton="true"
      @confirm="onSure"
      @cancel="onCancel"
    />
    <div v-if="tips" :class="['ph-app__tips', kaPos]">
      {{tips}}
    </div>
    <ph-button
      class="ph-app__action"
      v-if="!wore && isDelivery"
      :disabled="iLoading"
      type="primary"
      size="large"
      @click="putOn"
    >
      一键佩戴
    </ph-button>
    <ph-button
      class="ph-app__action"
      v-if="wore && isDelivery && cancellable"
      :disabled="iLoading"
      type="primary"
      size="large"
      @click="showDialog"
    >
      取消佩戴
    </ph-button>
    <ph-button
      class="ph-app__action"
      v-if="wore && !cancellable && isDelivery"
      :disabled="true"
      type="primary"
      size="large"
    >
      已领取
    </ph-button>
    <ph-button
      class="ph-app__action"
      v-if="!isDelivery"
      :disabled="true"
      type="primary"
      size="large"
    >
      {{statusText}}
    </ph-button>
    <div
      v-if="isNotStart && creativeData"
      class="ph-app__time"
    >
      活动将于{{startTime}}开始
    </div>
    <ph-checkbox
      v-if="showAgreement"
      v-model="agreement"
      class="ph-app__checkbox"
    >
      同步到微博
    </ph-checkbox>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import toast from '@components/toast';
import PhDialog from '@components/dialog';
import PhButton from '@components/button';
import PhCheckbox from '@components/checkbox';
import {cheka, CHEKA_EVENTS, CHEKA_EVENT_TYPE} from '@utils/cheka';
import userService from '@services/user';
import {getUrlParam} from '@utils/url';
import { DELIVERY_STATUS } from '@data/deliveryStatus';
import { POS_MAP } from '@data/posMap';

export default {
  name: 'InteractionIcon',
  components: {
    PhDialog,
    PhButton,
    PhCheckbox
  },
  props: {
    tips: String,
    kaPos: {
      type: String,
      required: true
    },
    creativeData: {
      type: Object,
      default() {
        return {};
      },
    }
  },
  data() {
    return {
      show: false,
      iLoading: false,
      wore: !!this.creativeData['set_status'],
      agreement: true
    };
  },
  computed: {
    cancellable() {
      return this.kaPos !== 'pos_comment_bubble';
    },
    statusText() {
      return this.isNotStart? '活动未开启': '活动已结束';
    },
    startTime() {
      return dayjs.unix(this.creativeData['start_time']).format('YYYY[年]MM[月]DD[日]');
    },
    isNotStart() {
      return this.creativeData['delivery_status'] && this.creativeData['delivery_status'] === DELIVERY_STATUS.NOT_START.id;
    },
    isOver() {
      return this.creativeData['delivery_status'] && this.creativeData['delivery_status'] === DELIVERY_STATUS.OVER.id;
    },
    isDelivery() {
      return this.creativeData['delivery_status'] && this.creativeData['delivery_status'] === DELIVERY_STATUS.DELIVERY.id;
    },
    showAgreement() {
      return this.creativeData &&
        this.isDelivery &&
        !this.wore &&
        !this.iLoading;
    }
  },
  mounted() {
    this.activeId = getUrlParam('active_id').toUpperCase();
  },
  methods: {
    showDialog() {
      if (!this.wore) {
        this.onSure();
      } else {
        this.show = !this.show;
        this.iLoading = true;
      }
    },
    putOn() {
      this.iLoading = true;
      cheka('send', {
        eventid: CHEKA_EVENTS.ACTION_SUCCESS.id,
        eventtype: CHEKA_EVENT_TYPE.BEFORE_PUT_ON.name,
      });
      userService.setInteractionIcon(POS_MAP[this.kaPos].set, {
        active_id: this.activeId,
        is_feed: this.agreement ? 1 : 0,
        set_switch: 1,
      }).then(() => {
        cheka('send', {
          eventid: CHEKA_EVENTS.ACTION_SUCCESS.id,
          eventtype: CHEKA_EVENT_TYPE.AFTER_PUT_ON.name,
        });
        this.wore = true;
        toast({
          content: '佩戴成功',
          type: 'success'
        });
      }).catch((error) => {
        cheka('send', {
          eventid: CHEKA_EVENTS.ACTION_FAILD.id,
          eventtype: CHEKA_EVENT_TYPE.AFTER_PUT_ON.name,
        });
        toast({
          content: error.data.message,
          type: 'success'
        });
      }).finally(() => {
        this.iLoading = false;
      });
    },
    onCancel() {
      cheka('send', {eventid: CHEKA_EVENTS.ACTION_CANCEL.id});
      this.iLoading = false;
    },
    onSure() {
      cheka('send', {
        eventid: CHEKA_EVENTS.ACTION_SUCCESS.id,
        eventtype: CHEKA_EVENT_TYPE.BEFORE_TAKE_OFF.name,
      });
      userService.setInteractionIcon(POS_MAP[this.kaPos].set, {
        active_id: this.activeId,
        set_switch: 0,
      }).then(() => {
        cheka('send', {
          eventid: CHEKA_EVENTS.ACTION_SUCCESS.id,
          eventtype: CHEKA_EVENT_TYPE.AFTER_TAKE_OFF.name,
        });
        this.wore = false;
        toast({
          content: '取消成功',
          type: 'success'
        });
      }).catch(() => {
        cheka('send', {
          eventid: CHEKA_EVENTS.ACTION_FAILD.id,
          eventtype: CHEKA_EVENT_TYPE.AFTER_TAKE_OFF.name,
        });
        toast({
          content: '网络不好，请稍后重试',
          type: 'error'
        });
      }).finally(() => {
        this.iLoading = false;
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.ph-app__tips {
  text-align: center;
  color: #939393;
  font-size: 12px;
  transform: scale(.91);
  &.pos_comment_bubble {
    width: 298px;
    margin: 25px auto;
  }
  &.pos_basic_interaction_icon {
    width: 283px;
    margin: 17px auto;
    // visibility: hidden;
  }
}
.ph-app__action {
  margin-top: 0;
}
.ph-app__checkbox {
  margin-bottom: 0;
}
.ph-app__time {
  margin-top: 6px;
}
</style>
